var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,2.5h-5.6V1.8C14.8,0.8,14,0,13,0H8C7,0,6.2,0.8,6.2,1.8v0.6H0.6C0.3,2.5,0,2.7,0,3.1v13.5  c0,1,0.8,1.8,1.8,1.8h17.3c1,0,1.8-0.8,1.8-1.8V3.1C21,2.8,20.8,2.5,20.4,2.5C20.4,2.5,20.4,2.5,20.4,2.5z M7.4,1.8  c0-0.3,0.3-0.6,0.6-0.6H13c0.3,0,0.6,0.3,0.6,0.6v0.6H7.4V1.8z M19.5,3.7l-1.9,5.7c-0.1,0.3-0.3,0.4-0.6,0.4h-3.5V9.2  c0-0.3-0.3-0.6-0.6-0.6H8c-0.3,0-0.6,0.3-0.6,0.6v0.6H4c-0.3,0-0.5-0.2-0.6-0.4L1.5,3.7H19.5z M12.3,9.8v1.2H8.7V9.8H12.3z   M19.8,16.6c0,0.3-0.3,0.6-0.6,0.6H1.8c-0.3,0-0.6-0.3-0.6-0.6V6.9l1,2.9c0.3,0.8,1,1.3,1.8,1.3h3.5v0.6c0,0.3,0.3,0.6,0.6,0.6H13  c0.3,0,0.6-0.3,0.6-0.6v-0.6H17c0.8,0,1.5-0.5,1.8-1.3l1-2.9L19.8,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.d1bb7695ae0cfb06ddabc2b2a310b282.svg";
export { ForwardRef as ReactComponent };